import { useContext } from "react"
import get from "lodash.get"
import isPlainObject from "lodash.isplainobject"
import mapValues from "lodash.mapvalues"

import { ContentContext } from "../components/ContentProvider"

const useContent = ({ path }) => {
  const allContent = useContext(ContentContext)
  const selectedContent = path ? get(allContent, path.replaceAll("/", ".")) : allContent

  return localizeContent(allContent.language.current, selectedContent)
}

function localizeContent(language, content) {
  if (isPlainObject(content)) {
    if (language in content) {
      return content[language]
    } else {
      return mapValues(content, (item) => localizeContent(language, item))
    }
  }
  return content
}

export default useContent
